import {
  REQUEST_GET_USERS_INBOXES,
  SET_USERS_INBOXES,
  REQUEST_GET_MANAGERS_BAWABA,
  REQUEST_SET_MANAGERS_BAWABA,
  REQUEST_UPDATE_ASSIGNEMENT_INBOXES,
  REQUEST_COUNT_INBOXES,
  SET_COUNT_INBOXES,
} from 'containers/AttributionManager/constants';

export const requestGetUsersInboxes = () => {
  return {
    type: REQUEST_GET_USERS_INBOXES,
  };
};

export const requestSetUsersInboxes = (payload: any) => {
  return {
    type: SET_USERS_INBOXES,
    payload,
  };
};

export const requestGetManagersBawaba = () => {
  return {
    type: REQUEST_GET_MANAGERS_BAWABA,
  };
};

export const requestSetManagersBawaba = (payload: any) => {
  return {
    type: REQUEST_SET_MANAGERS_BAWABA,
    payload,
  };
};

export const requestUpdateAssignementInboxes = (
  payload: any,
  successCallBack: Function,
) => {
  return {
    type: REQUEST_UPDATE_ASSIGNEMENT_INBOXES,
    payload,
    successCallBack,
  };
};
export const requestGetCountInboxes = () => {
  return {
    type: REQUEST_COUNT_INBOXES,
  };
};
export const setCountInboxes = (payload: any) => {
  return {
    type: SET_COUNT_INBOXES,
    payload,
  };
};
